/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Open_LinkInputs */

const en_gc_story_open_link = /** @type {(inputs: Gc_Story_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the XLSX quick start`)
};

const zh_gc_story_open_link = /** @type {(inputs: Gc_Story_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读 XLSX 入门指南`)
};

/**
* | output |
* | --- |
* | "Read the XLSX quick start" |
*
* @param {Gc_Story_Open_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_open_link = /** @type {((inputs?: Gc_Story_Open_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Open_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_open_link(inputs)
	return zh_gc_story_open_link(inputs)
});
export { gc_story_open_link as "gc.story.open.link" }